var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content-container mx-auto h-full mt-6",class:{'app-content-container-boxed': _vm.appContentWidth === 'boxed'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }